angular.module('ihestiaWidgets.policyDetails')
  .controller('ihestiaLifePersonSearchModalCtrl', ['$scope', function($scope) {
    $scope.helper.init();
    $scope.tplData = $scope.helper.tplData;

    $scope.clientSearch = $scope.helper.clientSearch;
    $scope.chooseClient = $scope.helper.chooseClient;
    $scope.sortBy = $scope.helper.chooseClient;
  }]);
